import { ReactNode } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Content from 'assets/js/components/Content';
import { isAxiosError } from 'axios';
import { ErrorCodes } from 'constants/error-codes';
import { GivebutterAxiosError } from 'types/error';

interface ErrorBoundaryProps {
    children: ReactNode;
    FallbackComponent?: React.ComponentType<FallbackProps> | null;
}

const Fallback = ({ error }: FallbackProps) => {
    const errorMessage = isAxiosError(error) ? (error.response?.data?.message ?? null) : null;

    return (
        <Content>
            <div className="flex flex-col items-center justify-center gap-4">
                <FontAwesomeIcon size={'2x'} icon={faLock} />
                <h1 className={'text-2xl font-medium'}>
                    {errorMessage ?? "You don't have permission to view this page"}
                </h1>
                <p className={'text-center'}>
                    Please contact your organization admin for permission to access this feature.
                </p>
            </div>
        </Content>
    );
};

const PermissionErrorBoundary = ({
    children,
    FallbackComponent = Fallback,
}: ErrorBoundaryProps) => (
    <ErrorBoundary
        onError={error => {
            if ((error as GivebutterAxiosError).response?.status !== ErrorCodes.FORBIDDEN) {
                throw error;
            }
        }}
        fallbackRender={props => (FallbackComponent ? <FallbackComponent {...props} /> : null)}
        resetKeys={[location.pathname]}
    >
        {children}
    </ErrorBoundary>
);

export { PermissionErrorBoundary };
